import { createSelector } from '@reduxjs/toolkit';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import type { RootState } from 'reactApp/store';

export const getSassQueryProduct = createSelector(
    (state: RootState, productFromQuery: string | undefined) => ProductsSelectors.getProductById(state, productFromQuery),
    (productFromQuery) => productFromQuery
);
